import { render } from "./CardBoard.vue?vue&type=template&id=e343294e&scoped=true"
import script from "./CardBoard.vue?vue&type=script&lang=js"
export * from "./CardBoard.vue?vue&type=script&lang=js"

import "./CardBoard.vue?vue&type=style&index=0&id=e343294e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e343294e"]])

export default __exports__